<template>
  <div class="section-category section-full">
    <grid-view
      :type="'staff'"
      :items="staffs"
      :show-staff-avatar="displayStaffAvatar"
      @pickItem="pickStaff">
    </grid-view>
  </div>
</template>

<script>
import GridView from '@/components/GridView.vue';
import { SET_CONFIRM_MODAL, SET_MESSAGE_MODAL } from '@/store/mutation-types';
import { SET_STAFF_STATION } from '@/store/action-types';
import { mapGetters } from 'vuex';

export default {
  name: 'staffs',
  components: {
    GridView,
  },
  computed: {
    staffPage() { return this.getMap('staffPage', true); },
    staffs() {
      return this.getArray('staffs').filter((staff) => {
        const isCurrentLocation = !!(
          staff.location
          && String(staff.location) === String(this.user.location.id)
        );
        return (this.isRole(staff.subRoles, 'Order taker / Staff / Waitress') || this.isRole(staff.subRoles, 'Other Staff'))
          && (this.staffPage === null || isCurrentLocation === this.staffPage);
      }).sort((a, b) => a.ref - b.ref);
    },
    staffMap() {
      return this.$store.state.staff.staffs;
    },
    user() {
      return this.$store.state.auth.user;
    },
    displayStaffAvatar() {
      return !!(this.user && this.user.location && this.user.location.displayStaffAvatar === true);
    },
    station() { return this.getMap('user', true).station; },
    ...mapGetters([
      'checkStaffLocation',
    ]),
  },
  methods: {
    isRole(items, key) {
      let flag = false;
      items.forEach((item) => {
        const role = this.getObject(item, 'roles');
        if (role && role.name === key) flag = true;
      });
      return flag;
    },
    async pickStaff(staff) {
      if (!this.isCashier) {
        this.$store.commit(SET_MESSAGE_MODAL, this.$gettext('Permission denied'));
        return;
      }
      const isCurrentLocation = !!(
        staff.location
        && String(staff.location) === String(this.user.location.id)
      );
      const data = {
        staffId: staff.id,
        setStationNull: !this.checkStaffLocation(staff),
        station: this.checkStaffLocation(staff) ? null : this.station.id,
      };
      const modalHeaderText = `${isCurrentLocation
        ? this.$gettext('sign out staff')
        : this.$gettext('sign in staff')} ${staff.firstName} ${staff.lastName}`;
      this.$store.commit(SET_CONFIRM_MODAL, {
        action: modalHeaderText,
        context: this,
        data,
        func: () => this.$store.dispatch(SET_STAFF_STATION, data),
      });
    },
  },
  mounted() {
    console.log('mounted staffs');
    console.log(this.$store.state.staff.staffs);
    const { path } = this.$router.currentRoute;
    if (path.includes('in')) {
      this.$store.state.staff.staffPage = true;
    } else if (path.includes('out')) {
      this.$store.state.staff.staffPage = false;
    }
  },
};

</script>
